import styled from '@emotion/styled';

const StyledTabsContainer = styled.div`
    padding: 0 0.5rem 0.5rem 0.5rem;
`

export default function TabsContainer({ children, className="" }) {
    return <StyledTabsContainer className={className}>{children}</StyledTabsContainer>
}